// Libs
import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
	cursor: pointer;
	transition: transform 0.15s ease, filter 0.15s ease;
	&:hover {
		transform: scale(1.15);
		filter: drop-shadow(0 0 1px rgba(255, 255, 255, 0.7));
	}
`;

export default ({ fill = 'white', fillOpacity = '0.80' }) => (
	<Svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		style={{ color: fill }}
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M15.502 14H14.708L14.432 13.726C15.407 12.589 16 11.115 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.115 16 12.588 15.408 13.725 14.434L14.001 14.708V15.5L18.999 20.491L20.49 19L15.502 14ZM9.5 14C7.014 14 5 11.986 5 9.5C5 7.015 7.014 5 9.5 5C11.985 5 14 7.015 14 9.5C14 11.986 11.985 14 9.5 14Z'
			fill={fill}
			fillOpacity={fillOpacity}
		/>
	</Svg>
);
